import React from 'react';
import IndexEditPlan from '../../components/actionPlan/editPlan/indexEditPlan';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

export const columns = [
  {
    name: 'id',
    label: 'Id',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
    },
  },
  {
    name: 'started_at',
    label: 'Registro',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRender: (value) => (
        <>
          {moment(value).format('LT')} <br />
          {moment(value).calendar()}
        </>
      ),
    },
  },
  {
    name: 'created_at',
    label: 'Abertura',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRender: (value) => (
        <>
          {moment(value).format('LT')} <br />
          {moment(value).calendar()}
        </>
      ),
    },
  },
  {
    name: 'contract_item',
    label: 'Equipamento',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRender: (value) => value?.nickname,
    },
  },
  {
    name: 'description',
    label: 'Ocorrência',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'justify',
        },
      }),
    },
  },
  {
    name: 'solution',
    label: 'Ação',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'justify',
        },
      }),
    },
  },
  {
    name: 'cause',
    label: 'Causa',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'justify',
        },
      }),
    },
  },
  {
    name: 'id',
    label: 'Editar',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
          width: '10%',
        },
      }),
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRender: (_, tableMeta) => (
        <IndexEditPlan
          id={tableMeta.rowData[0]}
          page={tableMeta.tableState.page}
          perPage={tableMeta.tableState.rowsPerPage}
          orderBy={tableMeta.tableState.sortOrder.name}
          order={tableMeta.tableState.sortOrder.direction}
          search={tableMeta.tableState.searchText}
        />
      ),
    },
  },
];
